/**
 * @generated SignedSource<<08db4f01560332a8dd3e129bb34d333f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type AssetFileType = "document" | "image" | "subtitle" | "unknown" | "video" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type UpdateAssetFormFieldsFragment$data = {
  readonly fileType: AssetFileType;
  readonly url: string;
  readonly " $fragmentSpreads": FragmentRefs<"DiscoVideoFragment">;
  readonly " $fragmentType": "UpdateAssetFormFieldsFragment";
};
export type UpdateAssetFormFieldsFragment$key = {
  readonly " $data"?: UpdateAssetFormFieldsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"UpdateAssetFormFieldsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UpdateAssetFormFieldsFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fileType",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DiscoVideoFragment"
    }
  ],
  "type": "Asset",
  "abstractKey": null
};

(node as any).hash = "fbd7449d9177cf3a1c9370bb17b3c83f";

export default node;
